import OpuSessionWorkspace from '../features/opu/layouts/session-workspace';

// TSS vite/01 §"Pages are thin". Full-screen OPU items workspace (no sidebar),
// opened in its own tab from the session modal. Auth/permission gated in app.jsx.
export default function OpuSessionPage() {
    return <OpuSessionWorkspace />;
}
